<template>
  <div name="VideoList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">一般影音列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">影音</li>
              <li class="breadcrumb-item active">一般影音列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->
    <!-- Main content -->
    <div id="video" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <!-- <div class="b-filter">
              <el-button
                type="info"
                :class="{current:-1==filterParams.categoryId}"
                @click="selectByType($event,-1,0)"
              >全部</el-button>
              <el-button
                type="info"
                @click="selectByType($event,index,category.id)"
                v-for="(category,index) in categoryList.slice(0,8)"
                :class="{current:index==filterParams.categoryId}"
                v-bind:key="category.id"
              >{{category.sgL_Type_Name}}</el-button>
            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs">
                <el-input
                  class="col-lg-2"
                  placeholder="搜尋一般影片"
                  v-model="filterParams.activeSearch"
                ></el-input>
                <el-select
                  v-model="filterParams.typeId"
                  placeholder="請選擇類型"
                  @onChange="searchStatus()"
                  clearable
                >
                  <el-option label="請選擇類型" value="0"></el-option>
                  <el-option
                    v-for="category in categoryList"
                    v-bind:key="category.id"
                    :label="category.sgL_Type_Name"
                    :value="category.id"
                  ></el-option>
                </el-select>
                <el-input
                  class="col-lg-2"
                  placeholder="搜尋上傳者"
                  clearable
                  v-model="filterParams.authorSearch"
                ></el-input>
                <el-select
                  v-model="filterParams.status"
                  placeholder="请选择發佈狀態"
                  @onChange="searchStatus()"
                  clearable
                >
                  <el-option label="全部" value="-1"></el-option>
                  <el-option label="公開" value="1"></el-option>
                  <el-option label="隱藏" value="0"></el-option>
                </el-select>
              </div>
              <div class="card-body">
                <el-table :data="getList" border v-loading="isload" row-key="id"   @cell-click="cellclick">
                  <el-table-column label="一般影片" sortable width="480">
                    <template slot-scope="scope">
                      <div class="b-video-block mr-2 clearfix">
                        <div class="b-video-thumbnail">
                          <div class="b-video-responsive">
                            <div class="b-video-sizer">
                              <div
                                class="b-video-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${scope.row.imageFile}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                          <div class="b-duration">
                            <span>{{ scope.row.mov_VSourceTimeFormat }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="b-title">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'WatchVideo',
                            params: { id: scope.row.id, itemtype: 'video' },
                          }"
                          >{{ scope.row.sgL_Mov_VSubject }}</router-link
                        >
                      </span>
                      <span
                        class="b-tag"
                        v-if="scope.row.sgL_Mov_VKeyword != null"
                      >
                        <a
                          v-for="words in scope.row.sgL_Mov_VKeyword.split(',')"
                          v-bind:key="words"
                          >{{ words }}</a
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sgL_MasterSortName" label="類型">
                    <template slot-scope="scope">
                      <el-link type="primary">
                        {{ scope.row.sgL_MasterSortName }}
                      </el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    sortable
                    label="上傳日期 / 狀態"
                    prop="data"
                    width="165"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.sgL_Mov_VAddTimerF }}</span>
                      <br />
                      <span
                        v-if="scope.row.sgL_Mov_VPublicshare == true"
                        class="subtext b-public"
                        >公開</span
                      >
                      <span v-else class="subtext b-unlisted">未公開</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sgL_Mem_DisplayName"
                    label="上傳者"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <el-link type="primary">{{
                        scope.row.sgL_Mem_DisplayName
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    sortable
                    label="尺寸 / 大小"
                    prop="size"
                    width="190"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.sgL_Mov_VSourceScreen }}</span><br/>
                      <span>{{ scope.row.sgL_Mov_VSourceSizeF }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sgL_Mov_VViewQuantity"
                    sortable
                    label="瀏覽量"
                    width="68"
                  ></el-table-column>
                  <!-- <el-table-column prop="PraiseCount" sortable label="讚好" width="60"></el-table-column>
                  <el-table-column prop="sgL_Mov_VMessage" sortable label="留言" width="60"></el-table-column>
                  <el-table-column prop="sgL_Mov_VFavorite" sortable label="收藏" width="60"></el-table-column> -->
                  <el-table-column
                    prop="ShareCount"
                    sortable
                    label="分享"
                    width="60"
                  ></el-table-column>
                  <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="
                          open(
                            $event,
                            scope.row.exquisiteId,
                            `您確定將影片[${scope.row.sgL_Mov_VSubject}]從影音精選中移出？`,
                            '移除精選',
                            'removeFeatured'
                          )
                        "
                        v-if="scope.row.isExquisite == true"
                        >移除精選</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="
                          open(
                            $event,
                            scope.row.id,
                            `您確定將影片[${scope.row.sgL_Mov_VSubject}]加入影音精選？`,
                            '加入精選',
                            'addFeatured'
                          )
                        "
                        v-else
                        >加入精選</el-button
                      >
                      <!-- <el-button type="primary" size="mini" @click="editMovie(scope.row.id)">編輯</el-button> -->
                      <el-button
                        type="danger"
                        size="mini"
                        @click="
                          open(
                            $event,
                            scope.row.id,
                            `您確定將影片[${scope.row.sgL_Mov_VSubject}]刪除？`,
                            '刪除影片'
                          )
                        "
                        >刪除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <el-pagination background layout="prev, pager, next" :total="1000" :page-sizes="[10,11,12]"></el-pagination> -->
              </div>
              <div class="row">
                <div class="col-lg-4 offset-lg-7">
                  <!--  引用分页组件 -->
                  <pagination
                    v-if="pageParams.pageshow"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                  />
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>

          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
  </div>
</template>
<!-- DataTables --> 
<!-- page script --> 
<script>
import { mapState, mapGetters, mapMutations, mapAction } from "vuex";
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  name: "VideoList",
  data() {
    return {
      isload: true,
      curretncss: "current",
      VideoList: [],
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageshow: true,
      },
      //查询参数
      filterParams: {
        authorSearch: "", //查询作者
        activeSearch: "", //查询标题
        status: "-1",
        categoryId: -1, //记录当前选中的类型
        typeId: "", //type为0为查询全部
      },
    };
  },
  beforeRouteUpdate(to, from, next) {
    //初始化tv类别
    // this.ToggleType(to.params.VideoType);
    next();
  },
  created() {
    this.VideoType = this.$route.params.VideoType; //获取路由参数
    this.GetVideoList();
  },
  mounted() {},
  watch: {
    "filterParams.activeSearch": {
      handler: function (newval, oldval) {
        this.ByfilterTvList();
      },
    },
    "filterParams.authorSearch": {
      handler: function (newval, oldval) {
        this.ByfilterTvList();
      },
    },
    "filterParams.status": {
      handler: function (newval, oldval) {
        this.ByfilterTvList();
      },
    },
    "filterParams.typeId": {
      handler: function (newval, oldval) {
        this.ByfilterTvList();
      },
    },
    VideoList(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.isload = false;
      }
    },
  },
  methods: {
    async GetVideoList() {
      let param = {
        SGL_Moive_TypeId: this.filterParams.typeId,
        // Sorting:'SizeSpanCount',
        sGL_IsPublic: this.filterParams.status,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        Title: this.filterParams.activeSearch,
        CreateName: this.filterParams.authorSearch,
      };
      this.$api.VideoApi.AdminVideoList(param).then((result) => {
        // this.$set(this.VideoList, result.data.result.items);
        this.VideoList = result.data.result.items;
        this.pageParams.total = result.data.result.totalCount;
        if (this.VideoList.length <= 0) {
          this.isload = false;
        }
      });
    },
    searchStatus() {
      this.GetVideoList();
    },
     cellclick(row, column, $event, cell) {
      if (column.property == "sgL_Mem_DisplayName") {
        this.filterParams.authorSearch = row.sgL_Mem_DisplayName;
      }
      if (column.property == "sgL_MasterSortName") {
        this.filterParams.typeId = row.sgL_MasterSort;
      }
    },
    editMovie(id) {
      //跳转组件
      this.$router.push({ name: "uploadTV", query: { Id: id } });
    },
    //按条件查询
    ByfilterTvList() {
      this.handleCurrentChange(1);
    },
    //上传tv点击方法
    uploadTV() {
      //跳转组件
      this.$router.push({ path: "/Backstage/uploadTV" });
    },
    //打开模态框
    open(e, Id, operator, title, method) {
      this.$confirm(operator, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (method == "removeFeatured" || method == "addFeatured") {
            await this.Choice(Id, method);
          } else {
            await this.DeleteTv(Id);
          }
        })
        .catch((e) => {
          this.$message({
            type: "info",
            message: "操作取消",
          });
        });
    },
    //根据分类查询数据，更新页码为第一页
    selectByType(e, index, typeId) {
      this.filterParams.typeId = typeId;
      this.filterParams.categoryId = index; //当前选中的类型下标index
      //追加选中的样式
      if (index > 0) {
        this.curretncss = "";
      } else {
        this.curretncss = "current";
      }
      this.handleCurrentChange(1);
    },
    //加入精选与移除精选
    Choice(Id, method) {
      //调用移除精选的方法
      let params = {
        sgL_Moive_Id: Id,
      };
      if (method == "addFeatured") {
        this.$api.VideoApi.AddAdminExquisite(params).then((result) => {
          if (result.data.success == true) {
            this.$message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
          } else {
            this.$message({
              type: "warning",
              message: result.data.error.message,
            });
          }

          this.GetVideoList();
        });
      } else {
        this.$api.VideoApi.removeAdminExquisite(params).then((result) => {
          if (result.data.success == true) {
            this.$message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
          } else {
            this.$message({
              type: "warning",
              message: result.data.error.message,
            });
          }
          this.GetVideoList();
        });
      }
    },
    //删除
    DeleteTv(Id) {
      let params = {
        Id: Id,
      };
      this.$api.VideoApi.AdmindelMovie(params).then((result) => {
        if (result.data.success == true) {
          this.GetVideoList();
          Message({
            type: "success",
            message: "刪除成功",
          });
        } else {
          Message({
            type: "warning",
            message: result.data.error.message,
          });
        }
        this.handleCurrentChange(1);
      });
    },

    //更改显示当前页码
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetVideoList();
    },
    //更改显示条目
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetVideoList();
    },
  },
  beforeMount() {
    let admin = this.$store.getters.getAdminUser;
    let permission = this.$store.getters.getPermission;
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  computed: {
    //store获取影片的分类
    ...mapGetters({ categoryList: "getVideoCategorygetters" }),
    getList() {
      return this.VideoList;
    },
  },
  components: {
    pagination,
  },
};
$(function () {
  //分页与搜索表单配置
  //   $("#soonnettv-list").DataTable({
  //     paging: false,
  //     lengthChange: true,
  //     searching: false,
  //     ordering: true,
  //     info: false,
  //     autoWidth: false
  //   });
  $(".video--upload---success").click(function () {
    Message({
      message: "影片上傳成功",
      type: "success",
      showClose: false,
      timeout: 600,
      callback: () => {
        //router.go(-1);
      },
    });
  });
  $(".video--edit---success").click(function () {
    Message({
      message: "影片已修改成功",
      type: "success",
    });
  });
  $(".video--remove---success").click(function () {
    Message({
      message: "影片已刪除",
      type: "success",
    });
  });
  $(".featured--add---success").click(function () {
    Message({
      message: "影片已新增至影音精選",
      type: "success",
    });
  });
  $(".featured--remove---success").click(function () {
    Message({
      message: "影片已從影音精選中移除",
      type: "success",
    });
  });
  $(".related--add---success").click(function () {
    Message({
      message: "影片已與賽事關聯成功",
      type: "success",
    });
  });
  $(".related--remove---success").click(function () {
    Message({
      message: "影片已與賽事已取消關聯",
      type: "success",
    });
  });
});
</script>
<style scoped>
.margs {
  margin: 15px;
}
</style>>


// WEBPACK FOOTER //
// src/components/AdminVideo/VideoList.vue